// Live users/{uid}/subscriptionData/planDetails for the signed-in user: null until it loads,
// {} for an account without one (treated as Free everywhere).
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebase';

export const isProPlan = plan => (plan?.currentPlan || '').toLowerCase() === 'pro';

export default function usePlan() {
  const uid = auth.currentUser?.uid;
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    if (!uid) return undefined;
    return onSnapshot(
      doc(db, 'users', uid, 'subscriptionData', 'planDetails'),
      snap => setPlan(snap.data() || {}),
      () => setPlan({}),
    );
  }, [uid]);
  return plan;
}
